module.exports = __webpack_public_path__ + "img/loading.4650e764.svg";